<template>
  <quest-main
    title="Themes"
    copy="Various site themes can be managed here"
    :loading="loading"
  >
    <template v-slot:head>
      <router-link
        :to="{ name: 'themes-add' }"
        class="d-sm-inline-block btn btn-sm btn-primary shadow-sm"
      >
        <font-awesome-icon
          icon="plus"
          size="sm"
          class="text-white-50"
        ></font-awesome-icon>
        Add</router-link
      >
    </template>
    <template v-slot:body>
      <quest-card title="Theme collection">
        <quest-table id="theme-table" :columns="columns">
          <template v-if="themes.items.length > 0">
            <tr
              class="small align-middle"
              v-for="theme in themes.items"
              :key="theme.id"
            >
              <td>
                <router-link
                  :to="{
                    name: 'themes-edit',
                    params: { id: theme.id },
                  }"
                  >{{ theme.name || '(untitled)' }}</router-link
                >
              </td>
              <td>{{ lastModified(theme.modifiedUTC) }}</td>
              <td>
                <b-dropdown no-caret variant="link">
                  <template #button-content>
                    <font-awesome-icon
                      icon="ellipsis-v"
                      size="sm"
                      fixed-width
                      class="text-gray-400"
                    ></font-awesome-icon>
                  </template>
                  <b-dropdown-header>Actions</b-dropdown-header>
                  <b-dropdown-item
                    :to="{
                      name: 'themes-edit',
                      params: { id: theme.id },
                    }"
                    >View</b-dropdown-item
                  >
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item-button
                    @click="promptDelete(theme)"
                    text="danger"
                    variant="danger"
                    >Delete</b-dropdown-item-button
                  >
                </b-dropdown>
              </td>
            </tr>
          </template>
          <template v-if="themes.items.length === 0">
            <tr class="align-middle">
              <td :colspan="columns.length">
                <div class="small text-center py-5">
                  There are no themes in the system
                </div>
              </td>
            </tr>
          </template>
        </quest-table>
        <quest-pager
          v-if="themes.total > pageSize"
          @changePage="changePage"
          :currentPage="page"
          :itemCount="themes.total"
          :pageSize="pageSize"
        ></quest-pager>
      </quest-card>
      <b-modal v-model="showModal" centered title="Delete">
        <p class="my-4">
          Are you sure you wish to delete theme '{{
            toDelete ? toDelete.name || 'untitled' : 'untitled'
          }}'?
        </p>
        <template v-slot:modal-footer>
          <button
            class="btn btn-secondary btn-sm"
            type="button"
            @click="cancelPromptDelete"
          >
            Cancel</button
          ><button
            class="btn btn-danger btn-sm"
            type="button"
            @click="confirmPromptDelete"
          >
            Delete
          </button>
        </template>
      </b-modal>
    </template>
  </quest-main>
</template>

<script>
import { success, error } from '../helpers'
import moment from 'moment'
import 'moment-timezone'
import {
  QuestMain,
  QuestTable,
  QuestCard,
  QuestModal,
  QuestPager,
} from './structure'
import { ThemeService } from '../services'
import PagedResult from '../models/paged-result'

export default {
  name: 'themes',
  components: {
    QuestMain,
    QuestTable,
    QuestCard,
    QuestPager,
    QuestModal,
  },
  data() {
    return {
      pageSize: 10,
      page: 1,
      term: '',
      themes: new PagedResult(),
      columns: ['Name', 'Modified', ''],
      toDelete: null,
      showModal: false,
      loading: true,
    }
  },
  mounted() {
    this.changePage(1)
  },
  methods: {
    changePage(page) {
      new ThemeService()
        .list(page, this.pageSize, this.term)
        .then((data) => {
          this.themes = data
          this.page = page
        })
        .finally((_) => (this.loading = false))
    },
    lastModified(date) {
      return moment(`${date}Z`).tz('Australia/Melbourne').format('lll')
    },
    promptDelete(theme) {
      this.toDelete = theme
      this.showModal = true
    },
    cancelPromptDelete() {
      this.showModal = false
      this.toDelete = null
    },
    confirmPromptDelete() {
      new ThemeService()
        .delete(this.toDelete.id)
        .then((data) => {
          this.showModal = false

          if (data) {
            this.changePage(1)
            success(`Deleted theme #`, this.toDelete.name)
          } else {
            error(`Failed to delete theme #`, this.toDelete.name)
          }
        })
        .finally((_) => (this.toDelete = null))
    },
  },
}
</script>
